;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ArtItemController', ArtItemController)

  /* @ngInject */
  function ArtItemController ($scope, $rootScope, $q, $state, $timeout, $translate, $location, Utils, CONSTANTS, ToastService, ModalService, UdsModalService, AssetPreviewService, ArtsService) {
    $scope.location = 'materialsApproval'
    $scope.isOpening = false

    const getApprovalDialogController = () => $q.when(import('../../dialogs/approval/approval-dialog.controller'))
    const getDownloadDialogController = () => $q.when(import('../../dialogs/download/download-dialog.controller'))
    const getShareArtDialogController = () => $q.when(import('../../dialogs/share-art/share-art-dialog.controller'))
    const getOutdatedArtApprovalDialogController = () => $q.when(import('../../dialogs/outdated-art-approval-dialog/outdated-art-approval-dialog.controller'))

    const api = {
      getApprovalDialogController,
      getDownloadDialogController,
      getShareArtDialogController,
      getOutdatedArtApprovalDialogController,
      _showApprovalModal,
      _getPreviewAssets,
      _openOldApprovalDialog
    }
    this.getApi = () => api

    activate()

    function activate () {
      $timeout(() => {
        $('.art-item-options-dropdown').dropdown()
      }, 100, false)
    }

    $scope.getThumbUrl = function (art) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_THUMBNAIL_ID, [art.id])
      url += '?' + art.updatedAt
      return url
    }

    $scope.openApprovalDialog = function (art) {
      if ($scope.isOpening) return
      $scope.isOpening = true

      const temporarilyAvailable = art.temporarilyAvailable?.length ? art.temporarilyAvailable[0] : null
      const urlParams = $location.search()

      let modalType = null
      if (art.unavailable || temporarilyAvailable?.reason === 'ARCHIVED_TEMPLATE') {
        modalType = 'UNAVAILABLE'
      } else if (art.templateHasUpdate || temporarilyAvailable?.reason === 'OUTDATED_TEMPLATE') {
        modalType = 'OUTDATED'
      }

      if (!urlParams.art) {
        if (modalType) {
          api.getOutdatedArtApprovalDialogController().then(({ OutdatedArtApprovalDialogController }) => {
            return ModalService.showModal({
              templateId: 'outdatedArtApproval.html',
              templateUrl: '/arts/dialogs/outdated-art-approval-dialog/outdated-art-approval-dialog.html?$$REVISION$$',
              destroyable: true,
              observeChanges: true,
              allowMultiple: true,
              controller: OutdatedArtApprovalDialogController,
              data: {
                type: modalType
              }
            }).then(showModal => {
              if (showModal) {
                api._showApprovalModal(art)
              }
            }).finally(() => {
              $scope.isOpening = false
            })
          }).catch(() => {
            $scope.isOpening = false
          })
        } else {
          api._showApprovalModal(art).finally(() => {
            $scope.isOpening = false
          })
        }
      }
    }

    $scope.shouldShowIcon = function (art, icon) {
      return art.shared_art.some(shared => shared && shared.socialType === icon)
    }

    $scope.openPostLink = function (art, icon) {
      const sharedPost = art.shared_art.find(shared => shared && shared.socialType === icon)
      let baseUrl = ''

      switch (icon) {
        case 'FACEBOOK':
          baseUrl = Utils.fnReplaceStringParams(CONSTANTS.FACEBOOK_POST_URL, [sharedPost.socialPostId])
          break
        case 'TWITTER':
          baseUrl = Utils.fnReplaceStringParams(CONSTANTS.TWITTER_POST_URL, [sharedPost.socialUsername, sharedPost.socialPostId])
          break
        case 'LINKEDIN':
          baseUrl = Utils.fnReplaceStringParams(CONSTANTS.LINKEDIN_POST_URL, [sharedPost.socialPostId])
          break
      }

      window.open(baseUrl, '_blank')
    }

    $scope.downloadArtClicked = function (art) {
      if (art.needApproval && art.approvalStatus !== 'APPROVED' && $rootScope.isUser()) {
        ToastService.showErrorToast($translate.instant('pendingApprovalErrorMsg'))
        return
      }

      api.getDownloadDialogController().then(({ DownloadDialogController }) => {
        const downloadDialog = UdsModalService.createModal({
          controller: DownloadDialogController,
          modalName: 'downloadDialog',
          data: {
            _iArtId: art.id,
            _customizationLevel: art.customizationLevel,
            _isCustomizable: art.isCustomizable,
            _sDownloadOption: art.downloadOption,
            _iProductId: art.productId,
            _oTemplate: art
          }
        })

        downloadDialog.open()
      })
    }

    $scope.shareArtClicked = function (art) {
      api.getShareArtDialogController().then(({ ShareArtDialogController }) => {
        const shareArtDialog = UdsModalService.createModal({
          controller: ShareArtDialogController,
          modalName: 'shareArtDialog',
          data: {
            art
          }
        })

        shareArtDialog.open()
      })
    }

    function _showApprovalModal (art) {
      return ArtsService.getArtPins(art.id).then((pins) => {
        // Art preview release date, any pin earlier from this date will not be positioned correctly.
        const oldPinsDate = new Date('2024-03-10')
        const oldPins = pins.filter(pin => new Date(pin.createdAt) <= oldPinsDate)

        if (oldPins.length) {
          api._openOldApprovalDialog(art)
          return
        }

        AssetPreviewService.openAssetPreview({
          asset: art,
          getPreviewAssets: api._getPreviewAssets,
          location: $scope.location
        })
      })
    }

    function _openOldApprovalDialog (art) {
      api.getApprovalDialogController().then(({ ApprovalDialogController }) => {
        ModalService.showModal({
          templateId: 'approvalDialog.html',
          templateUrl: '/arts/dialogs/approval/approval-dialog.html?$$REVISION$$',
          destroyable: true,
          controller: ApprovalDialogController,
          data: {
            id: art.id
          }
        }).then(() => {
          $location.search({ selectedTab: $state.params.selectedTab, page: $state.params.page })
        })
      })
    }

    function _getPreviewAssets () {
      return Promise.resolve({
        assets: $scope.arts,
        count: $scope.arts.length
      })
    }
  }
})()
